import { action, computed, observable } from 'mobx';

/*
  Single source of truth for the shared, cross-tab synth filter selections
  (Source Agent, Target/Resolver, Agent Site, Agent ASN, Agent Label).

  Owned by TestResultsState (`this.filters`). All tabs read/write the same instance,
  so cross-tab filtering is shared by construction. Values are stored as string arrays
  keyed by filter id; the store exposes backward-compatible accessors over this model.
*/

export const SYNTH_FILTER_IDS = ['sourceAgent', 'target', 'site', 'asn', 'label'];

function emptyValues() {
  return { sourceAgent: [], target: [], site: [], asn: [], label: [] };
}

export default class SynthFiltersModel {
  @observable
  values = emptyValues();

  get = (id) => this.values[id] || [];

  @action
  set = (id, next) => {
    this.values[id] = next;
  };

  @action
  reset = () => {
    this.values = emptyValues();
  };

  @computed
  get isActive() {
    return SYNTH_FILTER_IDS.some((id) => this.get(id).length > 0);
  }

  @computed
  get activeCount() {
    return SYNTH_FILTER_IDS.reduce((count, id) => count + (this.get(id).length > 0 ? 1 : 0), 0);
  }
}
